const LatLng = require('../../olycommon/geolocation/latlng');

const LOCATION_SEARCH_TEXT = 'Using your location';

class PickupAddressSearchController {
    constructor($element, locationService, pickupAddressSearchService, moveFocus) {
        this.$element = $element;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.searchPending = false;

        this.clearSearch();
        this.getLocation().then(location => this.search(location));
    }

    onKeyPress($event) {
        this.searchPending = true;
        if ($event && $event.keyCode === 13) {
            $event.preventDefault();
            this.searchPending = false;
            if (!this.searchString) {
                return;
            }
            this.search(this.searchString);
        }
    }

    onClickSearchInput() {
        if (this.searchString === LOCATION_SEARCH_TEXT) {
            this.searchString = '';
        }
    }

    onClickSearch($event) {
        $event.preventDefault();
        if (!this.searchString) {
            return;
        }
        this.searchPending = false;
        this.search(this.searchString);
    }

    search(searchTerm) {
        if (this.searchPending) {
            this.searchPending = false;
            return;
        }
        this.searchString = searchTerm instanceof LatLng ? LOCATION_SEARCH_TEXT : searchTerm;
        this.isSearching = true;
        this.hasSearched = true;

        this.performSearch(searchTerm).finally(() => {
            this.isSearching = false;
            this.moveFocus('._pickupAddressSearch-resultList');
        });
    }

    performSearch(searchTerm) {
        if (searchTerm instanceof LatLng) {
            return this.searchStoresByGeolocation(searchTerm);
        }

        if (isNaN(searchTerm)) {
            return this.searchSuburbs(searchTerm);
        }

        return this.searchStoresByPostcode(searchTerm);
    }

    searchSuburbs(searchTerm) {
        this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
        return this.pickupAddressSearchService.searchSuburbs(searchTerm).then((suburbs) => {
            this.suburbs = suburbs;
        });
    }

    searchStoresByPostcode(postcode) {
        this.searchMode = this.pickupAddressSearchService.searchModes.stores;
        return this.pickupAddressSearchService.searchByPostcode({ postcode })
            .then(pickupStores => this.setStores({ stores: pickupStores }));
    }

    searchStoresByGeolocation(position) {
        this.searchMode = this.pickupAddressSearchService.searchModes.stores;
        return this.pickupAddressSearchService.searchByGeolocation(position)
            .then(pickupStores => this.setStores({ stores: pickupStores }));
    }

    getLocation() {
        return this.locationService.getCurrentLocation();
    }

    clearSearch() {
        this.searchPending = false;
        this.hasSearched = false;
        this.isSearching = false;
        this.searchString = '';
        this.setStores({ stores: [] });
    }

    resetSearch() {
        this.clearSearch();
        this.moveFocus('._pickupAddressSearch-input');
    }
}

const pickupAddressSearchComponentDefinition = {
    bindings: {
        suburbs: '=',
        searchMode: '=',
        isSearching: '=',
        hasSearched: '=',
        searchString: '=',
        setStores: '&',
    },
    controller: ['$element', 'LocationService', 'PickupAddressSearchService', 'MoveFocus', PickupAddressSearchController],
    template: require('./pickup-address-search.component.html').trim(),
};

module.exports = {
    PickupAddressSearchController,
    pickupAddressSearchComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/pickup-address-search.component.js